import React from "react";
import {
  // HiXCircle,
  // MdSkipNext,
  MdSkipPrevious,
  // MdExitToApp
} from "react-icons/md";
import { useTranslation } from "react-i18next";

export default function PreviousZoomPagePartButton(props) {
  const { t } = useTranslation();
  return (
    <>
      <button
        // disabled={props.isLoading}
        className={`button is-small modal-button`}
        onClick={props.onClickHandler}
        title={t("Previous")}
      >
        <span className="icon  has-text-light">
          <MdSkipPrevious className="fas fa-2x" />
        </span>
        <span className="has-text-light ">Previous</span>
      </button>
    </>
  );
}
